// ------------------------------------------------------------------ Seite „Schlüssel“ (nur Hauptadmin)
/** Auswahl für das Claude-Modell (Standard: Opus 5.5). */
export const KI_CLAUDE_MODELLE = [
    { id: 'claude-opus-5-5', name: 'Claude Opus 5.5 (Standard)' },
    { id: 'claude-fable-5-1', name: 'Claude Fable 5.1' },
    { id: 'claude-sonnet-5-5', name: 'Claude Sonnet 5.5 (schneller)' },
    { id: 'claude-haiku-5-5', name: 'Claude Haiku 5.5 (am schnellsten)' },
];
/** Werte, die auf der Seite „Schlüssel“ eingetragen werden können (gehen vor der .env). */
export const KI_EINSTELLBAR = ['CLAUDE_MODELL', 'OLLAMA_URL', 'OLLAMA_MODELL', 'OLLAMA_BILDMODELL', 'SEARXNG_URL'];
//# sourceMappingURL=ki.js.map